/* LCP House Record: progressive photo zoom inside existing popovers.
   Scoped to the custom product page; does not change the product or variant data. */
(function () {
  'use strict';
  var MIN = 1;
  var MAX = 4;
  function clamp(value, low, high) { return Math.max(low, Math.min(high, value)); }
  function pointDistance(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

  function initPopover(panel, section) {
    if (panel.dataset.lcpDeepZoomReady === 'true') return;
    var views = Array.from(panel.querySelectorAll('.lcp-house-pdp-zoom-photo'));
    var head = panel.querySelector('.lcp-house-pdp-zoom-head');
    if (!views.length || !head) return;
    panel.dataset.lcpDeepZoomReady = 'true';

    var controls = document.createElement('div');
    controls.className = 'lcp-house-deep-zoom-controls';
    controls.setAttribute('aria-label', 'Photograph magnification');
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '\u2212';
    minus.setAttribute('aria-label', 'Zoom out');
    var percent = document.createElement('output');
    percent.className = 'lcp-house-deep-zoom-percent';
    percent.textContent = '100%';
    percent.setAttribute('aria-label', 'Zoom level');
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Zoom in');
    controls.append(minus, percent, plus);
    head.insertBefore(controls, head.querySelector('.lcp-house-pdp-zoom-close'));

    var state = { view: null, image: null, scale: 1, x: 0, y: 0,
      pointers: new Map(), start: null, pinch: null, moved: false, suppressClick: false };

    function currentView() {
      return views.find(function (v) { return !v.hidden; }) || null;
    }
    function render() {
      if (!state.view || !state.image || state.view.hidden) return;
      var maxX = Math.max(0, (state.image.offsetWidth * state.scale - state.view.clientWidth) / 2);
      var maxY = Math.max(0, (state.image.offsetHeight * state.scale - state.view.clientHeight) / 2);
      state.x = clamp(state.x, -maxX, maxX);
      state.y = clamp(state.y, -maxY, maxY);
      state.image.style.transform = 'translate3d(' + state.x + 'px, ' + state.y +
        'px, 0) scale(' + state.scale + ')';
      state.view.classList.toggle('lcp-is-deep-zoomed', state.scale > 1.005);
      percent.textContent = Math.round(state.scale * 100) + '%';
      minus.disabled = state.scale <= MIN + 0.005;
      plus.disabled = state.scale >= MAX - 0.005;
    }
    function activate() {
      var next = currentView();
      if (next === state.view && state.image) return Boolean(next);
      views.forEach(function (v) {
        v.classList.remove('lcp-is-deep-zoomed');
        var image = v.querySelector('img');
        if (image) image.style.transform = '';
      });
      state.view = next;
      state.image = next ? next.querySelector('img') : null;
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      state.pointers.clear();
      state.start = null;
      state.pinch = null;
      state.moved = false;
      state.suppressClick = false;
      render();
      return Boolean(state.image);
    }
    function reset() {
      state.view = null;
      state.image = null;
      activate();
    }
    function zoomTo(nextScale, clientX, clientY) {
      if (!activate()) return;
      var rect = state.view.getBoundingClientRect();
      var fx = (clientX == null ? rect.left + rect.width / 2 : clientX) - rect.left - rect.width / 2;
      var fy = (clientY == null ? rect.top + rect.height / 2 : clientY) - rect.top - rect.height / 2;
      var previous = state.scale;
      state.scale = clamp(nextScale, MIN, MAX);
      var ratio = state.scale / previous;
      state.x = fx + (state.x - fx) * ratio;
      state.y = fy + (state.y - fy) * ratio;
      if (state.scale === 1) { state.x = 0; state.y = 0; }
      render();
    }

    minus.addEventListener('click', function () { zoomTo(state.scale - 0.5); });
    plus.addEventListener('click', function () { zoomTo(state.scale + 0.5); });

    views.forEach(function (view) {
      view.tabIndex = 0;
      view.setAttribute('role', 'button');
      view.setAttribute('aria-label', 'Zoom photograph. Click or press Enter to enlarge, drag to inspect, use wheel or pinch to adjust.');
      view.querySelectorAll('img').forEach(function (img) { img.draggable = false; });

      view.addEventListener('click', function (event) {
        if (!activate() || view !== state.view) return;
        if (state.suppressClick) { state.suppressClick = false; return; }
        zoomTo(state.scale >= MAX - 0.005 ? MIN : Math.min(MAX, Math.floor(state.scale) + 1),
          event.clientX, event.clientY);
      });
      view.addEventListener('wheel', function (event) {
        if (!activate() || view !== state.view) return;
        event.preventDefault();
        zoomTo(state.scale * (event.deltaY < 0 ? 1.2 : 1 / 1.2), event.clientX, event.clientY);
      }, { passive: false });
      view.addEventListener('keydown', function (event) {
        if (!activate() || view !== state.view) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          zoomTo(state.scale >= MAX - 0.005 ? MIN : Math.min(MAX, Math.floor(state.scale) + 1));
        } else if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          zoomTo(state.scale + 0.5);
        } else if (event.key === '-' || event.key === '_') {
          event.preventDefault();
          zoomTo(state.scale - 0.5);
        } else if (event.key === '0') {
          event.preventDefault();
          zoomTo(MIN);
        }
      });

      view.addEventListener('pointerdown', function (event) {
        if (!activate() || view !== state.view || (event.pointerType === 'mouse' && event.button !== 0)) return;
        state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        state.suppressClick = false;
        state.moved = false;
        try { view.setPointerCapture(event.pointerId); } catch (error) {}
        if (state.pointers.size === 1) {
          state.start = { x: event.clientX, y: event.clientY, tx: state.x, ty: state.y };
          state.pinch = null;
        } else if (state.pointers.size === 2) {
          var points = Array.from(state.pointers.values());
          var rect = view.getBoundingClientRect();
          var midX = (points[0].x + points[1].x) / 2;
          var midY = (points[0].y + points[1].y) / 2;
          state.pinch = { distance: Math.max(1, pointDistance(points[0], points[1])),
            scale: state.scale, x: state.x, y: state.y,
            focusX: midX - rect.left - rect.width / 2,
            focusY: midY - rect.top - rect.height / 2 };
        }
      });
      view.addEventListener('pointermove', function (event) {
        if (!state.pointers.has(event.pointerId) || view !== state.view) return;
        state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (state.pointers.size >= 2 && state.pinch) {
          var points = Array.from(state.pointers.values());
          var rect = view.getBoundingClientRect();
          var mx = (points[0].x + points[1].x) / 2 - rect.left - rect.width / 2;
          var my = (points[0].y + points[1].y) / 2 - rect.top - rect.height / 2;
          state.scale = clamp(state.pinch.scale *
            pointDistance(points[0], points[1]) / state.pinch.distance, MIN, MAX);
          state.x = mx + (state.pinch.x - state.pinch.focusX) * state.scale / state.pinch.scale;
          state.y = my + (state.pinch.y - state.pinch.focusY) * state.scale / state.pinch.scale;
          state.moved = true;
          state.suppressClick = true;
          render();
        } else if (state.start) {
          var dx = event.clientX - state.start.x;
          var dy = event.clientY - state.start.y;
          if (Math.hypot(dx, dy) > 6) {
            state.moved = true;
            state.suppressClick = true;
          }
          if (state.scale > 1) {
            state.x = state.start.tx + dx;
            state.y = state.start.ty + dy;
            render();
          }
        }
      });
      function finishPointer(event) {
        if (!state.pointers.has(event.pointerId)) return;
        state.pointers.delete(event.pointerId);
        if (state.pointers.size === 1) {
          var p = Array.from(state.pointers.values())[0];
          state.start = { x: p.x, y: p.y, tx: state.x, ty: state.y };
          state.pinch = null;
        } else if (state.pointers.size === 0) {
          state.start = null;
          state.pinch = null;
        }
      }
      view.addEventListener('pointerup', finishPointer);
      view.addEventListener('pointercancel', finishPointer);
    });

    panel.addEventListener('toggle', function () {
      if (panel.matches(':popover-open')) {
        requestAnimationFrame(reset);
      } else {
        state.pointers.clear();
        state.view = null;
        views.forEach(function (view) {
          view.classList.remove('lcp-is-deep-zoomed');
          var img = view.querySelector('img');
          if (img) img.style.transform = '';
        });
      }
    });
    var finish = section.querySelector('#lcp-house-variant');
    if (finish) finish.addEventListener('change', function () {
      requestAnimationFrame(reset);
    });
    window.addEventListener('resize', function () {
      if (panel.matches(':popover-open')) render();
    });
    reset();
  }

  function init() {
    document.querySelectorAll('.lcp-house-pdp, .lcp-house-home').forEach(function (section) {
      section.querySelectorAll('.lcp-house-pdp-image-popover[popover], .lcp-house-image-popover[popover]').forEach(function (panel) {
        initPopover(panel, section);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();